import React from 'react';

import { ReactComponent as FuelTank } from './fuel-tank.svg';

function FarmbotFuelTankIcon() {
  return <FuelTank width={18} />;
}

export default FarmbotFuelTankIcon;
